import React from 'react';
import { Modal} from 'antd';
import FormZonaInfluencia from './FormZonaInfluencia';
const ModalZonaInfluencia = ({
    open,
    onClose,
    reloadData,
    onCreated
}) => {
    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            centered
            width={700}
            title="Crear Zona de Influencia"
        >
            <FormZonaInfluencia

    onSuccess={async (
        newZona
    ) => {

        await reloadData();

        onCreated(newZona);

    }}
/>

        </Modal>
    );
};

export default ModalZonaInfluencia;